export class SocketModule {
  socketName = "";
  url = "";
  // 回调
  onOpen = false;
  // 禁用重连
  useReconnect = false;
  // 重连计数
  timer = "";
  // 重连数
  count = 0;
  // socket服务实例
  socketServer = null;
  // 注册消息回调列表
  messageList = {};
  // 全局事件
  messageGlobal = () => {};
  // 初始化
  constructor(name = "", inputurl = "", { useReconnect = false, onOpen = () => {} } = {}) {
    if (inputurl) {
      this.url = `${window.location.protocol === "https:" ? "wss:" : "wss:"}//${inputurl}`;
      this.socketName = name;
      this.init();
      if (useReconnect) {
        this.useReconnect = useReconnect;
      }
      if (onOpen) {
        this.onOpen = onOpen;
      }
    }
  }
  // 主socket实例
  static mainSocket = new SocketModule();
  static mainSocketSend = function (data) {
    if (this.mainSocket) {
      this.mainSocket.send(data, 123);
    }
  };
  static setMainSocket = (socket) => {
    const list = this.mainSocket.messageList;
    const msgglobal = this.mainSocket.messageGlobal;
    this.mainSocket = socket;
    this.mainSocket.messageList = list;
    this.mainSocket.messageGlobal = msgglobal;
  };
  async readMessage(data) {
    let message = JSON.parse(await data.data.text());
    // console.log('message',await data.data.text())
    if (Object.hasOwn(message, "payload") && Object.hasOwn(message.payload, "array") && Object.hasOwn(message.payload, "limit") && Object.hasOwn(message.payload, "position")) {
      let hexString = atob(message.payload.array);

      let bytes = new Uint8Array(hexString.length);
      for (let i = 0; i < hexString.length; i++) {
        bytes[i] = hexString[i].codePointAt();
      }
      message.payload = new Blob([bytes.buffer], { type: message.mime });
    }
    return message;
  }

  init() {
    this.socketServer = new WebSocket(this.url);
    this.socketServer.onopen = () => {
      console.log(this.socketName + "连接成功");
      if (this.useReconnect) {
        this.count = 0;
        this.timer = setInterval(() => {
          try {
            this.socketServer.send(JSON.stringify({ type: "PING" }));
          } catch (error) {
            clearInterval(this.timer);
          }
        }, 15 * 1000);
      }
      if (this.onOpen) {
        this.onOpen();
      }
    };
    this.socketServer.onclose = () => {
      console.log(this.socketName + "连接失败close");
      if (this.useReconnect) {
        this.reconnection();
      }
    };
    this.socketServer.onerror = () => {
      console.log(this.socketName + "连接失败error");
      if (this.useReconnect) {
        this.reconnection();
      }
    };
    this.socketServer.onmessage = async (originmsg) => {
      const msg = await this.readMessage(originmsg);
      const { type, mime, payload } = msg;
      this.messageGlobal(msg);
      // 遍历消息列表
      console.log("WebSocket", msg);
      if (type === "topic_data_change") {
        // 内容变化

        let subjectInfo = payload.topicInfo;
        console.log("subjectInfo", subjectInfo);
        window.appdispatch({ type: "SET_SUBJECTINFO_PART", data: { ...subjectInfo } });
        window.appdispatch({
          type: "SET_MEMOINFO",
          data: { content: subjectInfo.memos[0].content, data: { ...subjectInfo.memos[0], content: subjectInfo.memos[0].content } },
        });
      } else if (type === "topic_user_data_change") {
        // 受邀加入讨论组
        //topic_user_data_change在线用户
        let users = payload.users;
        window.appdispatch({ type: "SET_ON_LINE", data: users });
      } else if (type === "notice_message_post") {
        //有新消息产生
        let messageId = payload.messageId;
        console.log(messageId);
        window.appdispatch({ type: "SET_BOTTOMBAR_MSG", data: true });
        window.appdispatch({ type: "SET_NOTICE_MSG", data: messageId });
      } else if (type === "chat_message_post") {
        //有讨论新消息产生
        window.appdispatch({ type: "SET_NEW_CHAT", data: true });
        window.appdispatch({ type: "SET_CHAT_MSG", data: payload });
      } else if (type === "topic_user_remove") {
        //讨论组移除当前用户
        window.appdispatch({ type: "SET_USER_REMOVE", data: true });
      }
    };
  }
  // 重连逻辑
  reconnection() {
    if (this.count > 10) return;
    this.count++;
    clearInterval(this.timer);
    setTimeout(() => {
      this.init();
    }, 3000);
  }
  // 发送消息
  send(params) {
    if (this.socketServer) {
      this.socketServer.send(JSON.stringify(params));
    }
  }
  // 注册事件
  register(message, callback) {
    this.messageList[message] = callback;
  }
  // 注册全局事件
  registerGlobal(callback) {
    this.messageGlobal = callback;
  }
}
